/**
 * Shared image upload helper for Firebase Storage.
 * Used by check-in ID capture, ChartMind professional ID verification, etc.
 *
 * @param {object} storage - Firebase Storage instance (from firebaseApp.storage())
 * @param {string} base64Image - Base64-encoded image data (no data URL prefix)
 * @param {string} storagePath - Full path in Storage (e.g. chartmindSettings/userId/id-documents/front.jpg)
 * @returns {Promise<string>} Download URL of the uploaded file
 */
export async function uploadImageToStorage(storage, base64Image, storagePath) {
  if (!storage || !base64Image || !storagePath) {
    throw new Error('uploadImageToStorage: storage, base64Image, and storagePath are required');
  }
  const byteString = atob(base64Image);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  const blob = new Blob([ab], { type: 'image/jpeg' });

  const ref = storage.ref().child(storagePath);
  const snapshot = await ref.put(blob);
  const downloadUrl = await snapshot.ref.getDownloadURL();
  return downloadUrl;
}
